exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".open-report {\n  cursor: pointer;\n  display: inline-block;\n}\n.open-report span {\n  color: #c10f6d;\n}\n", ""]);

// exports
